// Harry Potter's scar in the 12x16 box of the fire: the zigzag 10,0.5 → 3.5,7.25 → 8.75,8.5 → 2,15.5
// with sharp ends, 3px wide at its mitred corners, so it weighs about as much as the fire
export const BOLT_VIEW_BOX = '0 0 12 16';

export const BOLT_PATH = 'M10 0.5L0.6 8.1L5.85 9.35L2 15.5L11.65 7.65L6.4 6.4Z';

// A spark is a short jagged line drawn along the x axis from its start
export const SPARK_PATH = 'M0 0L1.8 -0.7L2.6 0.6L4.4 -0.1';

// The sparks start at the ends and the outer corners of the bolt and fly away from it (the angle is in degrees).
// Two discharges take turns: the first one sparks at the top end and the right corner, the second one
// at the left corner and the bottom end
export const DISCHARGES = [
  [
    { x: 10, y: 0.5, angle: -46 },
    { x: 11.65, y: 7.65, angle: -16 },
  ],
  [
    { x: 0.6, y: 8.1, angle: 164 },
    { x: 2, y: 15.5, angle: 134 },
  ],
];
